import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

import { ApiService } from 'src/app/core/services/api.service';
import {
  PaymentChannelPurchasePlanParams,
  PaymentChannelPurchasePlanResponse,
  GetConsumerEligibilityParams,
  GetConsumerEligibilityResponse,
  UpdateUserPlanParams,
  UpdateUserPlanResponse,
  GetPlanEligibilityParams,
  GetPlanEligibilityResponse,
} from '../../';

@Injectable({
  providedIn: 'root',
})
export class EligibilityService {
  private paymentChannelPurchasePlanResponseSubject = new Subject<any>();
  public paymentChannelPurchasePlanResponse =
    this.paymentChannelPurchasePlanResponseSubject
      .asObservable()
      .pipe(distinctUntilChanged());

  constructor(private readonly apiService: ApiService) {}

  /**
   *
   * @param getConsumerEligibilityParams
   * @returns
   */
  getConsumerEligibility(
    getConsumerEligibilityParams: GetConsumerEligibilityParams
  ): Observable<GetConsumerEligibilityResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getConsumerEligibilityParams
    );

    return this.apiService.get(`/v1/plans/consumer/eligibility`, params);
  }

  getPlanEligibility(
    getPlanEligibilityParams: GetPlanEligibilityParams
  ): Observable<GetPlanEligibilityResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getPlanEligibilityParams
    );

    if (getPlanEligibilityParams.groupId) {
      return this.apiService.get(
        `/v2/groups/${getPlanEligibilityParams.groupId}/plan-eligibility`,
        params
      );
    } else if (getPlanEligibilityParams.phoneNumber) {
      return this.apiService.get(
        `/v2/phone-numbers/${getPlanEligibilityParams.phoneNumber}/plan-eligibility`,
        params
      );
    } else if (getPlanEligibilityParams.lineId) {
      return this.apiService.get(
        `/v2/lines/${getPlanEligibilityParams.lineId}/plan-eligibility`,
        params
      );
    }
  }

  /**
   *
   * @param paymentChannelPurchasePlanParams
   * @returns
   */
  brandPurchasePlan(
    paymentChannelPurchasePlanParams: PaymentChannelPurchasePlanParams
  ): Observable<PaymentChannelPurchasePlanResponse> {
    return this.apiService
      .post(
        `/v1/plans/plan/${paymentChannelPurchasePlanParams.planUuid}/brand/${paymentChannelPurchasePlanParams.paymentChannelTypeSlug}`,
        paymentChannelPurchasePlanParams
      )
      .pipe(
        map((res: PaymentChannelPurchasePlanResponse) => {
          this.paymentChannelPurchasePlanResponseSubject.next(res);
          return res;
        })
      );
  }

  /**
   * Update user plan
   * @param updateTransactionParams
   * @returns
   * permissions: {mode: "+c", res: "userPlan.*"}
   */
  updateUserPlan(
    updateUserPlanParams: UpdateUserPlanParams
  ): Observable<UpdateUserPlanResponse> {
    return this.apiService
      .put(
        `/v1/user-plans/user-plan/${updateUserPlanParams.userPlanId}`,
        updateUserPlanParams
      )
      .pipe(
        map((res: UpdateUserPlanResponse) => {
          this.paymentChannelPurchasePlanResponseSubject.next({});
          return res;
        })
      );
  }
}
